import LineHotAirBalloonIcon from 'LuxKit/Icons/line/LineHotAirBalloonIcon'

const ICON_SIZES = {
  S: 48,
  M: 72,
} as const

interface Props {
  size: 'S' | 'M'
}

function LuxPlusExperienceDiscountCalendarLogo({ size }: Props) {
  return <LineHotAirBalloonIcon size={ICON_SIZES[size]} />
}

export default LuxPlusExperienceDiscountCalendarLogo
